import closingDetailsModalTemplate from './closingDetail.modal.html';
import _ from 'lodash';

class TaxationClosingsController {
  /* @ngInject */
  constructor(ClosingsService, $log, ModalFactory, $q, $timeout, $filter) {
    const that = this;

    that.closingList = [];
    that.loading = false;
    that.filterMonth = 0;
    that.filterPeriod = 'Tutti';
    that.sintesi = false;
    that.pagination = {
      currentPage: {
        number: 0,
        data: []
      },
      pageSize: 10
    };
    that.checkedAll = false;
    const date = new Date();
    that.start = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate());
    that.end = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    that.maxDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    that.makePagination = () => {
      that.loading = true;
      that.pagination.elementsCount = that.closingList.length;
      that.changePage(0);
      setTimeout(() => { that.loading = false; }, 100);
    };

    that.changePage = (page = 0) => {
      if (that.closingList === undefined) return;
      that.pagination.currentPage.number = page;
      const pageStart = page * that.pagination.pageSize;
      const pageEnd = pageStart + that.pagination.pageSize;
      that.pagination.currentPage.data = that.closingList.slice(pageStart, pageEnd);
    };

    // ==============STUBBONE DA TOGLIERE=======================================
    // that.stubList = [];
    // let time = new Date().getTime();
    // let i = 0;
    // for (i = 0; i < 115; i++) {
    //   that.stubList.push({
    //     creationDate: time,
    //     closedCashId: i,
    //     description: 'Closed cash ' + i,
    //     total: i + 10,
    //     firstInvoice: 'Invoice: ' + i,
    //     lastInvoice: 'Last Invoice: '+ i,
    //     totalTax: {
    //       ten: '10',
    //       twenty: '40',
    //       forty: '50'
    //     }
    //   });
    //   time = time - 259200000;
    // }
    // that.closingList = that.stubList;
    // that.makePagination();
    // ==============FINE STUBBONE DA TOGLIERE==================================

    that.toggleCheckAll = (data) => {
      that.checkedAll = !that.checkedAll;
      _.forEach(data, (m) => {
        that.toggleCheck(m);
      });
    };

    that.toggleCheck = (value) => {
      value.checked = value.checked ? false : true;  // eslint-disable-line
    };

    that.resetFilterMonth = () => {
      that.filterMonth = 0;
      that.filter();
      that.getAllClosings();
    };

    that.filter = () => {
      switch (that.filterMonth) {
        case '1':
          that.filterPeriod = '1 Mese';
          break;
        case '3':
          that.filterPeriod = '3 Mesi';
          break;
        case '6':
          that.filterPeriod = '6 Mesi';
          break;
        case 'datepicker':
          that.filterPeriod = `Dal ${$filter('amDateFormat')(that.start, 'DD/MM/YYYY')} al ${$filter('amDateFormat')(that.end, 'DD/MM/YYYY')}`;
          break;
        default:
          that.filterPeriod = 'Tutti';
          break;
      }

      if (that.filterMonth !== 0 && that.filterMonth !== '0') {
        that.getClosingbyTime(that.filterMonth);
      } else {
        that.getAllClosings();
      }
    };

    that.getAllClosings = () => {
      that.loading = true;
      that.closingList = [];
      ClosingsService.getAllClosing().then(
      (data) => {
        that.closingList = data;
        that.makePagination();
      },
      (error) => {
        $log.error(`ClosingService`, `getClosingRequest`, error);
        that.loading = false;
      });
    };

    that.getClosingbyTime = (month) => {
      let now = undefined;
      let interval = undefined;
      if (month !== 'datepicker') {
        now = new Date();
        interval = new Date();
        interval.setMonth(interval.getMonth() - month);
      } else {
        now = new Date(that.end);
        interval = new Date(that.start);
      }

      that.loading = true;
      that.closingList = [];

      ClosingsService.getClosingByDate(now.getTime(), interval.getTime()).then(
      (data) => {
        that.closingList = data;
        that.makePagination();
      },
      () => {
        that.loading = false;
      });
    };

    const openClosingModal = cash => $q((resolve, reject) => {
      const closeModal = (modal) => {
        modal.deactivate();
        $timeout(modal.destroy, 1000);
      };
      const modal = new ModalFactory({
        class: 'tiny',
        overlay: true,
        overlayClose: true,
        template: closingDetailsModalTemplate,
        contentScope: {
          cash,
          activate: () => {
          },
          cancel: () => {
            closeModal(modal);
            reject();
          }
        }
      });

      modal.activate();
    });

    that.showDetails = (close) => {
      openClosingModal(close);
    };

    that.makeZip = () => {
      const checkedList = that.closingList.filter(o => o.checked);
      ClosingsService.makeZip(checkedList, that.sintesi);
    };

    that.getAllClosings();
  }
}

export default TaxationClosingsController;



/** WEBPACK FOOTER **
 ** ./client/app/components/taxation/closings/closings.controller.js
 **/